import { Grid } from "@mui/material";
import React from "react";

export default function SelectedLoan(props: any) {
  return (
    <div
      style={{
        width: "100%",
        margin: props.margin ? props.margin : "auto",
        background: "#fff",
        marginTop: props.marginTop ? props.marginTop : "-2vh",
        paddingBottom: "2vh",
        marginBottom: "2vh",
        // props.color ? props.color :
      }}
    >
      {props.title != null || props.title != undefined ? (
        <span
          className="colorTitle fontWeight textFont16 mbottom10 "
          style={{
            marginTop: "-10px",
            marginRight: "30px",
            background: props.color ? "transparent" : "#fff",
            paddingRight: "5px",
            paddingLeft: "5px",
          }}
        >
          {props.title}
        </span>
      ) : (
        ""
      )}

      <div
        className="cardTabBorder cardTabBorderShadow borderCOlor"
        style={{
          backgroundColor: props.color ? props.color : "#fff",
          margin: props.setMargin ? props.setMargin : "",
        }}
      >
        <Grid
          container
          className=" textFont14"
          style={{
            lineHeight: "35px",
            paddingRight: "45px",
            paddingTop: "4vh",
            paddingBottom: "5vh",
          }}
        >
          <Grid item xs={4} sm={4} md={4}>
            <div>
              <span style={{ color: "#9AAFC4" }}>نام طرح: </span>
              <span style={{ color: "#34495E" }}>
                {props.value.loanTemplateTitle} <br />
                {props.value.isBySupplierCredit ? (
                  <b
                    style={{
                      textAlign: "right",
                      color: "#EE9D01",
                      fontSize: "10px",
                    }}
                  >
                    &nbsp; &nbsp;(تضمین از محل اعتبار تامین کننده
                    &nbsp;&nbsp;|&nbsp;&nbsp;اعتبار باقیمانده:{" "}
                    {props.value.supplierCredit.toLocaleString()}
                    &nbsp;&nbsp;ریال)
                  </b>
                ) : (
                  ""
                )}
              </span>
            </div>
          </Grid>
          {props.value.financialSupplierTitle && (
            <Grid item xs={4} sm={4} md={4}>
              <div>
                <span style={{ color: "#9AAFC4" }}>تامین کننده کالا:</span>
                <span style={{ color: "#34495E" }}>
                  {" "}
                  {props.value.financialSupplierTitle}
                </span>
              </div>
            </Grid>
          )}
          <Grid item xs={4} sm={4} md={4}>
            <div>
              <span style={{ color: "#9AAFC4" }}>سقف قابل اعطا:</span>
              <span style={{ color: "#34495E" }}>
                {" "}
                {props.value.loanAmount
                  ? props.value.loanAmount.toLocaleString()
                  : ""}{" "}
                ریال
              </span>
            </div>
          </Grid>
          <Grid item xs={4} sm={4} md={4}>
            <div>
              <span style={{ color: "#9AAFC4" }}> سود تسهیلات:</span>{" "}
              <span style={{ color: "#34495E" }}>
                {props.value.profitRate} %
              </span>
            </div>
          </Grid>
          <Grid item xs={4} sm={4} md={4}>
            <div>
              <span style={{ color: "#9AAFC4" }}>
                {" "}
                مهلت استفاده از تسهیلات:
              </span>
              <span style={{ color: "#34495E" }}>
                {" "}
                {/* {props.value.expirationDate_Persian} */}
              </span>
            </div>
          </Grid>
          {props.value.title ? (
            <Grid item xs={4} sm={4} md={4}>
              <div>
                <span style={{ color: "#9AAFC4" }}> نام پذیرنده:</span>{" "}
                <span style={{ color: "#34495E" }}>{props.value.title}</span>
              </div>
            </Grid>
          ) : null}
        </Grid>
      </div>
    </div>
  );
}
